import store from "src/store/store"
import DynamicFormTypes from "../../Types/DynamicFormsTypes"
import buildTemplateWithConfig from "./BuildTemplateWithConfig"
import buildTemplateWithoutConfig from "./BuildTemplateWithoutConfig"

/**
 * If the first item in the schema is a config object, then use the buildTemplateWithConfig function,
 * otherwise use the buildTemplateWithoutConfig function.
 * @param {DynamicFormTypes} form - DynamicFormTypes
 * @returns the template.
 */
const buildTemplate = (form: DynamicFormTypes) => {
    const schema = JSON.parse(form.FieldsSchema || "[]")
    const config = (schema[0] && schema[0].Type === "Config") ? JSON.parse(schema[0].CustomValues[0]) : null
    if (config && schema[0].CustomValues[1]) {
        const palette = JSON.parse(schema[0].CustomValues[1])
        store.dispatch({ type: "MERGE_EXISTING_FORM_PALETTE", payload: palette })
    }
    const template = config ? buildTemplateWithConfig.buildTemplate(config, schema) : buildTemplateWithoutConfig.buildTemplate(schema)
    return template
}

export default buildTemplate